import { useMsal } from "@azure/msal-react";
import ActionButton from "../../common/input-fields/ActionButton";
import { FieldVariants } from "../../common/input-fields/utils/appInputenum";
import { loginRequest } from "./authConfig";

/**
 * Renders a drop down button with child buttons for logging in with a popup or redirect
 */
 const LoginButton = () => {

    const { instance } = useMsal();

    const handleLogin = (loginType) => {
        if (loginType === "popup") {
            instance.loginPopup(loginRequest).catch(e => {
                console.log(e);
            });
        } else if (loginType === "redirect") {
            instance.loginRedirect(loginRequest).catch(e => {
                console.log(e);
            });
        }
    }
    return (
       <ActionButton
         label="Login"
         variant={FieldVariants.OUTLINED}
         onClick={() => handleLogin("redirect")}
         className="login-button" />
    )
}

export default LoginButton;